export default __webpack_public_path__ + "static/media/Roboto-Regular.d52fab6c.ttf";